export default "__VITE_ASSET__t8f2YHvl__"